import React from 'react';

const RandevuTerms = () => {
  return (
    <div className="min-h-screen bg-white text-gray-800 px-6 py-16">
      <h1 className="text-4xl font-bold mb-6 text-center">Kullanım Koşulları</h1>
      <p className="text-center text-gray-600 mb-4">Son güncelleme: 7 Temmuz 2026</p>
      <hr className="my-6" />

      <div className="max-w-3xl mx-auto space-y-6 text-justify leading-relaxed">
        <p>
          Bu kullanım koşulları, Randevu Defteri uygulamasını ("Uygulama") kullanımınızı düzenler.
          Uygulamayı indirerek veya kullanarak bu koşulları kabul etmiş sayılırsınız.
        </p>

        <h2 className="text-xl font-semibold mt-8">1. Hizmetin Kapsamı</h2>
        <p>
          Randevu Defteri, işletme sahiplerinin müşteri randevularını planlamasına, takip etmesine ve
          müşteri geçmişini yönetmesine yardımcı olan bir uygulamadır. Uygulama yalnızca işletme
          sahiplerinin ve yetkilendirdikleri kişilerin kullanımına yöneliktir.
        </p>

        <h2 className="text-xl font-semibold mt-8">2. Hesap ve Sorumluluk</h2>
        <p>
          Uygulamayı kullanmak için bir hesap oluşturmanız gerekir. Hesabınızın güvenliğinden, giriş
          bilgilerinizin gizliliğinden ve hesabınız üzerinden yapılan tüm işlemlerden siz sorumlusunuz.
          Hesap bilgilerinizi üçüncü kişilerle paylaşmayınız.
        </p>

        <h2 className="text-xl font-semibold mt-8">3. Veri Girişi ve KVKK Yükümlülüğü</h2>
        <p>
          Uygulamaya girdiğiniz müşteri bilgilerinin (ad, telefon numarası, notlar vb.) doğruluğundan ve
          bu bilgileri ilgili kişilerin bilgisi dahilinde kaydetmekten siz sorumlusunuz. 6698 sayılı
          Kişisel Verilerin Korunması Kanunu (KVKK) kapsamında müşterilerinize karşı veri sorumlusu
          sıfatı ve buna bağlı yükümlülükler, veri girişini yapan işletmeye aittir.
        </p>

        <h2 className="text-xl font-semibold mt-8">4. Ücretlendirme</h2>
        <p>
          Uygulama şu anda ücretsiz olarak sunulmaktadır. Gelecekte Uygulamanın tamamı veya bazı
          özellikleri ücretli hale getirilebilir ya da abonelik modeline geçilebilir. Böyle bir değişiklik
          yapılması halinde:
        </p>
        <ul className="list-disc ml-6 space-y-1">
          <li>Ücretlendirme, App Store üzerinden Apple'ın ödeme altyapısıyla gerçekleştirilir.</li>
          <li>Değişiklik öncesinde uygulama içinden bilgilendirme yapılır.</li>
          <li>Ücretli bir özelliği satın almadığınız sürece sizden herhangi bir ücret tahsil edilmez.</li>
          <li>Mevcut verileriniz, ücretlendirme değişikliği nedeniyle silinmez.</li>
        </ul>

        <h2 className="text-xl font-semibold mt-8">5. Hizmet Sürekliliği ve Sorumluluk Sınırı</h2>
        <p>
          Uygulama "olduğu gibi" sunulmaktadır. Hizmette yaşanabilecek kesinti, veri kaybı, gecikme veya
          hatalardan doğan doğrudan ya da dolaylı zararlardan uygulama geliştiricisi sorumlu tutulamaz.
          Önemli verilerinizi düzenli olarak kontrol etmeniz önerilir.
        </p>

        <h2 className="text-xl font-semibold mt-8">6. Kullanım Kısıtlamaları</h2>
        <p>
          Uygulamayı hukuka aykırı amaçlarla kullanmak, tersine mühendislik yapmak, sistemlere yetkisiz
          erişim denemek veya hizmetin işleyişini bozacak faaliyetlerde bulunmak yasaktır. Bu tür
          kullanımlar tespit edildiğinde hesabınız askıya alınabilir veya kapatılabilir.
        </p>

        <h2 className="text-xl font-semibold mt-8">7. Hesap Silme</h2>
        <p>
          Hesabınızı dilediğiniz zaman Ayarlar bölümünden kalıcı olarak silebilirsiniz. Silme işlemiyle
          birlikte tüm hesap ve randevu verileriniz sunucularımızdan kaldırılır. Bu işlem geri alınamaz.
        </p>

        <h2 className="text-xl font-semibold mt-8">8. Fikri Mülkiyet</h2>
        <p>
          Uygulamanın tasarımı, yazılımı, logosu ve içeriği geliştiriciye aittir; izinsiz kopyalanamaz ve
          çoğaltılamaz. Uygulamaya girdiğiniz veriler size aittir.
        </p>

        <h2 className="text-xl font-semibold mt-8">9. Değişiklikler</h2>
        <p>
          Bu koşullar gerektiğinde güncellenebilir. Önemli değişiklikler uygulama içinden duyurulur.
          Değişiklik sonrasında Uygulamayı kullanmaya devam etmeniz, güncel koşulları kabul ettiğiniz
          anlamına gelir.
        </p>

        <h2 className="text-xl font-semibold mt-8">10. İletişim</h2>
        <p>
          Bu koşullarla ilgili sorularınız için uygulama geliştiricisiyle iletişime geçebilirsiniz:
        </p>
        <p className="ml-4">
          E-posta: <a href="mailto:hi@n1inovasyon.com" className="text-blue-600">hi@n1inovasyon.com</a>
        </p>

        <div className="mt-12 p-4 bg-gray-100 rounded-lg">
          <p className="text-sm text-gray-600 text-center">
            Bu uygulamayı kullanarak yukarıdaki koşulları okuduğunuzu ve kabul ettiğinizi onaylarsınız.
          </p>
        </div>
      </div>
    </div>
  );
};

export default RandevuTerms;
